const tooltips = {
  penzugy: 'Rendszerben használatos fizetési módok és pénznem adatok rögzítésére szolgáló felület.',
  fizetesimod: 'A funkció célja, hogy meglévő fizetési módokat listázni lehessen, hogy a felvett fizetési módok láthatók, szerkeszthetők, törölhetők legyenek. Az Új fizetési mód gombbal új fizetési mód rögzítését teszi lehetővé az alkalmazás.',
  penznem: 'A felületen lehet új pénznemet rögzíteni, korábban rögzítetteket módosítani, törölni.',
  inflacio: 'A funkció célja, hogy a felhasználó megadhassa azokat az évre, típusra vonatkozó inflációk mértékét, amelyeket a rendszerben szeretne felhasználni.',
  banktipus: 'A felületen lehet új banktípust rögzíteni, korábban rögzítetteket módosítani, törölni.',
  bankszamla: 'A felületen lehet új bankszámlaszámot rögzíteni, korábban rögzítetteket módosítani, törölni.',
};

export default function getTooltip(name) {
  return tooltips[name];
}
